import { tsValidate, tsValidateArray, tsValidateMustExist, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { MetaPathwayAction_Types_WithoutProtocols, MetaPathwayAction_Types_WithProtocols } from './types.js';
import { isMetaPathwayAction_WithoutProtocol, isMetaPathwayAction_WithProtocol } from './utils.js';
const Validator_MetaPathwayAction_WithProtocol = {
    type: tsValidateValue([...MetaPathwayAction_Types_WithProtocols]),
    protocolIds: tsValidateArray(tsValidateUniqueId),
};
const Validator_MetaPathwayAction_WithoutProtocol = {
    type: tsValidateValue([...MetaPathwayAction_Types_WithoutProtocols]),
};
export const Validator_MetaPathwayAction = (instance) => {
    const error = tsValidate(instance, tsValidateMustExist);
    if (error)
        return error;
    if (isMetaPathwayAction_WithProtocol(instance))
        return tsValidate(instance, Validator_MetaPathwayAction_WithProtocol);
    if (isMetaPathwayAction_WithoutProtocol(instance))
        return tsValidate(instance, Validator_MetaPathwayAction_WithoutProtocol);
    // @ts-ignore
    return `Missing validator for meta pathway action of type ${instance.type}`;
};
//# sourceMappingURL=validator.js.map